import { Control, Controller, useFormContext } from "react-hook-form";
import { AgentMemories } from "../AgentMemories";
import { ToolSectionHeader } from "../ToolSectionHeader";
import { useMemo, useCallback } from "react";
import { Tool } from "../AssistantDetailsContent";

export const AgentMemoryFieldNCL = ({
  name,
  control,
  isDisabled,
}: {
  name: string;
  control: Control<Record<string, unknown>>;
  isDisabled?: boolean;
}) => {
  const form = useFormContext();

  const baseTools = form.watch("definition.base_tools") as Tool[] | undefined;
  const agentMemoryTool = useMemo(
    () => baseTools?.find((t) => t.type === "agent_memory"),
    [baseTools]
  );
  const isEnabled = agentMemoryTool?.enabled ?? false;

  const handleToggle = useCallback(
    (checked: boolean) => {
      if (isDisabled || !baseTools) return;
      const updated = baseTools.map((t) =>
        t.type === "agent_memory" ? { ...t, enabled: checked } : t
      );
      form.setValue("definition.base_tools", updated, { shouldDirty: true });
    },
    [baseTools, form, isDisabled]
  );

  return (
    <div className="flex flex-col gap-3">
      <ToolSectionHeader
        title="Agent Memory"
        subtitle="Persistent memory across all conversations"
        enabled={isEnabled}
        onToggle={handleToggle}
        isDisabled={isDisabled}
      />

      {isEnabled && (
        <div className="border rounded-md p-3">
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <AgentMemories
                memories={(field.value as any[]) ?? []}
                onChange={(updated) => field.onChange(updated)}
                isReadOnly={isDisabled}
              />
            )}
          />
        </div>
      )}
    </div>
  );
};
